import { ImageItem } from "@kontent-ai/gatsby-components/dist/image-element";
import React from "react";
import { Cta } from "../../elements/Cta/Cta";
import { CustomRichTextElement } from "../../elements/CustomRichTextElement/CustomRichTextElement";
import { KontentImageElement } from "../../elements/KontentImageElement/KontentImageElement";
import * as styles from "./FiftyFiftyFeaturedContent.module.css";
import {
  ComponentWidth,
  ComponentProps,
  KontentRichText,
} from "../../../types";
import { SectionWrapper } from "../../containers/SectionWrapper";

interface Props extends ComponentWidth, ComponentProps {
  orientation?: "text_left" | "text_right";
  style?: "green_background" | "cream_background";
  textAlignment?: "left" | "center";
  contentCategory?: string;
  subhead: string;
  dateTime?: string;
  text?: KontentRichText;
  ctas?: { label: string; href: string; target: string }[];
  image: {
    item: ImageItem;
    alt: string;
  };
  id: string;
}

export const FiftyFiftyFeaturedContent: React.FC<Props> = ({
  orientation,
  style,
  textAlignment,
  contentCategory,
  subhead,
  dateTime,
  text,
  ctas,
  width,
  image,
  ...props
}) => {
  const buildSectionClassName = () => {
    let className = styles.fiftyfiftyfeaturedcontent;

    if (orientation === "text_right") {
      className += " " + styles.reverse;
    }

    if (width === "contained") {
      className += " " + styles.contained;
    }

    return className;
  };

  const sectionClassName = buildSectionClassName();

  const renderCtas = () => {
    if (!ctas || ctas.length === 0) {
      return;
    }

    if (ctas && ctas?.length === 1) {
      return (
        <div
          className={styles.ctas + " " + styles[`count${ctas.length}`]}
          data-kontent-element-codename="link_configuration__link"
        >
          {ctas?.map((cta, idx) => {
            return (
              <Cta
                key={`cta-${idx}`}
                href={cta.href}
                target={cta.target}
                label={cta.label}
                invert={style === "green_background"}
              />
            );
          })}
        </div>
      );
    }

    return (
      <ul
        className={styles.ctas + " " + styles[`count${ctas?.length}`]}
        data-kontent-element-codename="link_configuration__link"
      >
        {ctas?.map((cta, idx) => {
          return (
            <li key={`cta-${idx}`}>
              <Cta
                href={cta.href}
                target={cta.target}
                label={cta.label}
                invert={style === "green_background"}
              />
            </li>
          );
        })}
      </ul>
    );
  };

  return (
    <SectionWrapper {...props}>
      <div className={sectionClassName}>
        <div
          className={
            style === "cream_background"
              ? `${styles.textPanel} ${styles.cream}`
              : styles.textPanel
          }
        >
          <div
            className={
              textAlignment === "center"
                ? `${styles.textContainer} ${styles.center}`
                : styles.textContainer
            }
          >
            {contentCategory && (
              <div
                className={styles.contentCategory}
                data-kontent-element-codename="content_category_tax"
              >
                {contentCategory}
              </div>
            )}
            <h2>{subhead}</h2>
            {dateTime && (
              <div
                className={styles.date}
                data-kontent-element-codename="date_time"
              >
                {dateTime}
              </div>
            )}
            {text && (
              <CustomRichTextElement
                content={text}
                data-kontent-element-codename="text"
              />
            )}

            {renderCtas()}
          </div>
        </div>
        <div
          className={styles.imagePanel}
          data-kontent-element-codename="image"
        >
          <KontentImageElement
            aspectRatio={1.45}
            objectFit="cover"
            layout="fullWidth"
            image={image?.item}
            alt={image?.alt}
          />
        </div>
      </div>
    </SectionWrapper>
  );
};
